import styled, { css } from 'styled-components';
import type { ProductCareTable as ProductCareTableSchema } from '@amplience/content-types/typings/c-product-care-table';
import { TypographyStyles, colours, spacing } from '@storefront/lib-global/stylings';
import { getLocalizedValue, transformTextToId } from '@storefront/lib-global/utils/transformers';

const moreThanOneLayout = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
`;

const S = {
  Container: styled.ul<{ $isMorethanOne: boolean }>`
    background-color: ${colours.LIGHTER_GREY};
    ${({ $isMorethanOne }) => $isMorethanOne && moreThanOneLayout}

    gap: ${spacing.XXXS};
    height: fit-content;
    padding: ${spacing.XXXS};
  `,
  Item: styled.li`
    margin: ${spacing.XXXXS};
    padding: 0;
  `,
  Title: styled.span`
    border-bottom: solid 1px ${colours.BLACK};
    display: block;
    margin: 0;
    padding: 0;
    padding-bottom: ${spacing.XXXXS};
    ${TypographyStyles.Body.Small.SemiBold}
  `,
  Description: styled.p`
    margin: 0;
    margin-top: ${spacing.XXXS};
    padding: 0;
    ${TypographyStyles.Body.Tiny.Regular}
  `,
};

export type ProductCareTableProps = ProductCareTableSchema;

export function ProductCareTable({ careBlock }: ProductCareTableProps) {
  if (!careBlock?.length) return null;
  return (
    <S.Container $isMorethanOne={careBlock?.length > 1}>
      {careBlock?.map((item) => (
        <S.Item key={transformTextToId(getLocalizedValue(item.title))}>
          <S.Title>{getLocalizedValue(item.title)}</S.Title>
          <S.Description>{getLocalizedValue(item.description)}</S.Description>
        </S.Item>
      ))}
    </S.Container>
  );
}
